import { observer } from "mobx-react-lite";

import { useStores } from "../../stores/useStores";
import { Choice, ChoiceDetail, SmallHeading } from "../ui/controls";
import { PaneHeader, PaneTitle } from "../ui/lists";
import { PhoneBack } from "../ui/PhoneBack";
import { AccountSettings } from "./AccountSettings";
import { SettingsBody, SettingsGroup } from "./settingsStyles";

/** How the app behaves on this device, apart from how it looks. */
export const GeneralSettings = observer(function GeneralSettings() {
    const { settings, navigation } = useStores();

    return (
        <>
            <PaneHeader>
                <PhoneBack label="Back to settings" onClick={() => navigation.go({ name: "settings" })} />
                <PaneTitle>General</PaneTitle>
            </PaneHeader>
            <SettingsBody>
                <AccountSettings />
                <SettingsGroup>
                    <SmallHeading>Editing</SmallHeading>
                    <Choice>
                        <input
                            type="checkbox"
                            checked={settings.holdToArrange}
                            onChange={(event) => settings.setHoldToArrange(event.target.checked)}
                        />
                        <span>
                            Hold a chord to start editing
                            <ChoiceDetail>
                                Turn this off on stage, so touching the sheet never starts editing. The Edit button in the display settings
                                always works.
                            </ChoiceDetail>
                        </span>
                    </Choice>
                </SettingsGroup>
            </SettingsBody>
        </>
    );
});
